import * as types from './mutation-types'
import store from "@/store";

export default {
  [types.LOAD_MAILS](state, data) {
    state.mails = data
  },
  [types.ADD_NEW_MAILS](state, data) {
    let mails = state.mails
    let dataToAdd = data.emails
    let dataToRemoveLength = dataToAdd.length;

    if(dataToRemoveLength > 10) {
      dataToAdd = dataToAdd.slice(0, 10);
    }

    if(parseInt(mails.current_page) === 1 && dataToRemoveLength > 0) {
      let mailsData = mails.data
      let newData = mailsData.slice(0, -dataToRemoveLength)
      mailsData = [...dataToAdd, ...newData]
      state.mails.data = mailsData
    }

    state.mails.total = state.mails.total + dataToRemoveLength
  },

  [types.ADD_MAIL](state, e) {
    if(e.user == store.getters['user/currentUser']?.id && parseInt(state.mails.current_page || 0) == 1){
      state.mails.data?.unshift(e.message)
      store.commit('folders/UPDATE_FOLDER')
    }
  },
  [types.DESTROY_MAIL](state, ids) {
    state.mails.data = state.mails.data.filter(item => !ids.includes(item.id));
  },
  [types.LOAD_USER_CONTACTS](state, data) {
    state.user_contacts = data
  },
  [types.LOAD_PRIORITIES](state, data) {
    state.priorities = data.data
  },
  [types.LOAD_ACTIVE_SIGNATURE](state, data) {
    state.active_signature = data.signature[0]
  },
  [types.LOAD_SIGNATURES](state, data) {
    state.signatures = data.signature
  },
  [types.LOAD_SCHEDULE_MAILS](state, data) {
    state.schedule_mails = data.data
  },
  [types.SET_UNSEEN_MAIL_COUNT](state, count) {
    state.unseenMailCount = count
  },
  [types.SET_CURRENT_MAIL](state, mail) {
    state.currentMail = mail
  },
  [types.SET_CONFIG_IMAP](state, config) {
    state.imapConfig = { email: config.username, fullname: config.fullname }
  },
  [types.MAKE_MAILS_AS_READ](state, ids) {
    state.mails.data = state.mails?.data?.map(mail =>
        ids.includes(mail.id)
            ? { ...mail, isSeen: true }
            : mail
    )
  },

  [types.MAKE_MAILS_AS_UN_READ](state, ids) {
    state.mails.data = state.mails?.data?.map(mail =>
        ids.includes(mail.id)
            ? { ...mail, isSeen: false }
            : mail
    )
  },

  [types.MAKE_MAILS_AS_IMPORTANT](state, ids) {
    state.mails.datas = state.mails?.data?.map(mail =>
        ids.includes(mail.id)
            ? { ...mail, isFlagged: true }
            : mail
    )
  },

  [types.MAKE_MAILS_AS_NOT_IMPORTANT](state, ids) {
    state.mails.data = state.mails?.data?.map(mail =>
        ids.includes(mail.id)
            ? { ...mail, isFlagged: false }
            : mail
    )
  },

  [types.RESET_CURRENT_MAIL](state) {
    state.currentMail = {}
  },

}
